import { useEffect, useState } from "react";
import {
  createEventOut,
  findByDni,
  findByMrz,
  findByPass,
  findByQR,
} from "../store/functions/userFunction";
import { Config, ISearchUser } from "../store/types/userTypes";
import { useStore } from "./useStore";
import {UserState} from "../passapp-sdk/types/userTypes";

const useSdk = (
  find?: ISearchUser,
  config?: Config,
  initialUser?: UserState
) => {
  const { authStore } = useStore();
  const [user, setUser] = useState<UserState | null>(null);
  const [error, setError] = useState(false);

  const searchUser = (find?: ISearchUser, initialUser?: UserState) => {
    if (find) {
      if (find.dni && find.countryCode && !find.firstname && !find.lastname) {
        findByDni(authStore.token, find.dni, find.countryCode, setUser, config);
      }
      if (find.dni && find.countryCode && find.firstname && find.lastname) {
        findByMrz(
          authStore.token,
          {
            dni: find.dni,
            country: find.countryCode,
            firstname: find.firstname,
            lastname: find.lastname,
          },
          setUser,
          config
        );
      }
      if (find.qr && find.rawQr) {
        findByQR(authStore.token, find.rawQr, setUser, config, find.userData);
      }
      if (find.pass && find.passUserId) {
        findByPass(
          authStore.token,
          authStore.country,
          { id: find.pass, user: find.passUserId },
          setUser,
          config,
          find.userData,
          find.rawPass
        );
      }
    } else {
      if (initialUser) {
        if (config && config.eventType === "out" && !config.editMode) {
          createEventOut(authStore.token, initialUser, setUser, config);
        } else {
          if (config) initialUser = { ...initialUser, config };
          setUser(initialUser);
        }
      } else {
        setError(true);
      }
    }
  };

  useEffect(() => {
    searchUser(find, initialUser);
  }, []);

  return { user, error, searchUser };
};

export default useSdk;
